// extracted by mini-css-extract-plugin
module.exports = {"container":"_8eb4c586"};